"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.waitForMutationResponse = exports.waitForData = exports.checkForErrorResponse = exports.parseErrorMessage = void 0;
var __1 = require("../..");
var logger_1 = require("../../logger");
var client_1 = require("../../client");
var parseErrorMessage = function (e) {
    if (typeof e === 'object' && e.error) {
        var cleaner = JSON.parse(e.error);
        return (cleaner.message) ? cleaner.message : e;
    }
    else {
        return "" + e;
    }
};
exports.parseErrorMessage = parseErrorMessage;
var checkForErrorResponse = function (args, response, errorCreator, reject, st) {
    if (st === void 0) { st = __1.store; }
    // check if reject is there (this might be outside of a promise lifecycle)
    var rejectWithError = function (error) {
        var which = reject || st.dispatch;
        which(errorCreator(args, exports.parseErrorMessage(error)));
    };
    try {
        var data = response.data, error = response.error;
        if (error) {
            rejectWithError(error);
        }
        else if (data) {
            return data;
        }
        else {
            rejectWithError(error);
        }
    }
    catch (error) {
        rejectWithError(error);
    }
};
exports.checkForErrorResponse = checkForErrorResponse;
var waitForData = function (args, queryCreator, actionCreator, errorCreator) {
    return new Promise(function (resolve, reject) {
        var queryWithVars = queryCreator(args);
        var callback = function (response) {
            try {
                var json = exports.checkForErrorResponse(args, response, errorCreator, reject);
                logger_1.Log.info("Response for args '" + args + "' received: " + json);
                if (resolve && json) {
                    resolve(actionCreator(json, args));
                    resolve = undefined;
                }
            }
            catch (error) {
                reject(errorCreator(args, error));
            }
        };
        var apolloClient = client_1.buildClient(args);
        // execute query
        apolloClient
            .query({
            query: queryWithVars.query,
            variables: queryWithVars.variables
        })
            .then(function (data) {
            callback(data);
        })
            .catch(function (error) {
            reject(errorCreator(args, error));
        });
    });
};
exports.waitForData = waitForData;
var waitForMutationResponse = function (args, mutationCreator, actionCreator, errorCreator) {
    return new Promise(function (resolve, reject) {
        var mutationWithVars = mutationCreator(args);
        var callback = function (response) {
            try {
                var json = exports.checkForErrorResponse(args, response, errorCreator, reject);
                logger_1.Log.info("Response for args '" + args + "' received: " + json);
                if (resolve && json) {
                    resolve(actionCreator(json, args));
                    resolve = undefined;
                }
            }
            catch (error) {
                reject(errorCreator(args, error));
            }
        };
        var apolloClient = client_1.buildClient(args);
        // execute query
        apolloClient
            .mutate({
            mutation: mutationWithVars.query,
            variables: mutationWithVars.variables
        })
            .then(function (data) {
            callback(data);
        })
            .catch(function (error) {
            reject(errorCreator(args, error));
        });
    });
};
exports.waitForMutationResponse = waitForMutationResponse;
//# sourceMappingURL=index.js.map